import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Card, Spinner } from 'react-bootstrap';
import api from './api';
import './KlinikTakvim.css'; // Birazdan oluşturacağımız CSS dosyası

function KlinikTakvim() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/klinik/randevular')
      .then(response => {
        setEvents(response.data);
      })
      .catch(error => {
        console.error("Takvim verileri yüklenirken hata oluştu!", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleEventClick = (clickInfo) => {
    // Takvimdeki bir randevuya tıklandığında detay sayfasına git
    navigate(`/randevu/${clickInfo.event.id}`);
  };

  if (loading) return <Spinner animation="border" variant="light" />;

  return (
    <Card className="glass-card p-3">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        events={events}
        eventClick={handleEventClick}
        height="80vh"
        locale="tr"
        buttonText={{
          today: 'Bugün',
          month: 'Ay',
          week: 'Hafta',
          day: 'Gün'
        }}
      />
    </Card>
  );
}

export default KlinikTakvim;